import React, { useRef } from 'react';
import Navbar from '../comps/Navbar';
import Footer from '../comps/Footer';
import PageHeader from './PageHeader';
import About from './About';
import Projects from './Projects';
import Services from './Services';
import Contact from './Contact';

export default function Home() {

    const aboutRef = useRef();
    const ServiceRef = useRef();
    const ContactRef = useRef();
    const projectRef = useRef();

    function scrollToAbout() {
        aboutRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    function scrollToService() {
        ServiceRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    function scrollToContact() {
        ContactRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    function scrollToProject() {
        projectRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    return (<div className=' z-0 relative  flex flex-col font-dongle text-4xl'>
        {/* Main content */}
        <Navbar  scrollToAbout={scrollToAbout} scrollToService={scrollToService} scrollToContact={scrollToContact} scrollToProject={scrollToProject} />
        <PageHeader />
        <About aboutRef={aboutRef} />
        <Services ServiceRef={ServiceRef} />
        <Projects  projectRef={projectRef} />
        <Contact ContactRef={ContactRef} />
       <Footer scrollToAbout={scrollToAbout} scrollToService={scrollToService} scrollToContact={scrollToContact} scrollToProject={scrollToProject} />
      </div>
      

    );
}
